"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogProductType = void 0;
var CatalogProductType;
(function (CatalogProductType) {
    CatalogProductType["BASE"] = "BASE";
    CatalogProductType["VITAMIN"] = "VITAMIN";
    CatalogProductType["BASE_TRIAL"] = "BASE_TRIAL";
    CatalogProductType["VITAMIN_TRIAL"] = "VITAMIN_TRIAL";
    CatalogProductType["TOILETRY"] = "TOILETRY";
    CatalogProductType["TOTE"] = "TOTE";
    CatalogProductType["BLUE_LIGHT_GLASSES"] = "BLUE_LIGHT_GLASSES";
    CatalogProductType["EYE_DROPS"] = "EYE_DROPS";
    CatalogProductType["EYE_MASK"] = "EYE_MASK";
    CatalogProductType["GLASSES_CASE"] = "GLASSES_CASE";
    CatalogProductType["GLASSES_CLOTH"] = "GLASSES_CLOTH";
    CatalogProductType["GLASSES_BOX"] = "GLASSES_BOX";
    CatalogProductType["OVERNIGHT_BAG"] = "OVERNIGHT_BAG";
    CatalogProductType["POST_CARD"] = "POST_CARD";
    CatalogProductType["EGIFT_CARD"] = "EGIFT_CARD";
})(CatalogProductType = exports.CatalogProductType || (exports.CatalogProductType = {}));
